import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { v4 as uuid } from 'uuid'

import TextField from '../../../../FormLegacy/FormFieldsV2/TextField'
import Checkbox from '../../../../FormLegacy/Checkbox'

const CustomQuestionsSelector = ({ values, setFieldValue, errors }) => {
  const { t } = useTranslation(['reservations', 'common'])
  const [question, setQuestion] = useState('')
  const [isRequired, setIsRequired] = useState(false)

  // Get existing questions from form values
  const questions = values.questions || []

  const addQuestion = () => {
    if (!question.trim()) return

    const newQuestion = {
      id: uuid(),
      question: question.trim(),
      isRequired,
    }

    const updatedQuestions = [...questions, newQuestion]
    setFieldValue('questions', updatedQuestions)
    clearInputs()
  }

  const removeQuestion = (questionIndex) => {
    const updatedQuestions = questions.filter((_, index) => index !== questionIndex)
    setFieldValue('questions', updatedQuestions)
  }

  const clearInputs = () => {
    setQuestion('')
    setIsRequired(false)
  }

  return (
    <div className="custom-questions-selector">
      {/* Add new question form */}
      <div className="custom-questions-selector__form">
        <div className="form-step__column">
          <TextField
            name="customQuestion"
            label={t('reservations:amenityForms.customQuestions.question')}
            placeholder={t('reservations:customQuestionsModal.enterCustomQuestionPlaceholder')}
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
          />
        </div>
        <div className="form-step__column">
          <div className="form-step__label">{t('reservations:customQuestionsModal.required')}</div>
          <div className="checkbox-wrapper">
            <Checkbox
              checked={isRequired}
              name="isRequired"
              id="question-required"
              onChange={() => setIsRequired(!isRequired)}
            />
          </div>
        </div>
        <div className="custom-questions-selector__add-button">
          <button
            type="button"
            onClick={addQuestion}
            disabled={!question.trim()}
            className="button button-black"
          >
            {t('reservations:amenityForms.customQuestions.addQuestion')}
          </button>
        </div>
      </div>
      {errors.questions && <div className="form-step__error">{errors.questions}</div>}
      {/* Display added questions */}
      {questions.length > 0 && (
        <div className="custom-questions-selector__questions">
          {questions.map((questionData, index) => (
            <div key={questionData.id} className="custom-questions-selector__question">
              <div className="form-step__column">
                <div className="form-step__label">
                  {t('reservations:amenityForms.customQuestions.question')}
                </div>
                <div className="custom-questions-selector__question-value">
                  {`${index + 1}. ${questionData.question}`}
                </div>
              </div>
              <div className="form-step__column">
                <div className="form-step__label">
                  {t('reservations:customQuestionsModal.required')}
                </div>
                <div className="custom-questions-selector__question-value">
                  {questionData.isRequired
                    ? t('reservations:amenityForms.yes')
                    : t('reservations:amenityForms.no')}
                </div>
              </div>
              <div className="custom-questions-selector__delete-button">
                <button
                  type="button"
                  onClick={() => removeQuestion(index)}
                  className="button button-secondary"
                >
                  {`✕ ${t('common:actions.delete')}`}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

CustomQuestionsSelector.propTypes = {
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
}

export default CustomQuestionsSelector
